// 应用版本号 —— 改这里之后 PR、deploy 后会显示在所有页面页脚
// 命名规则：major.minor.patch（语义化）
//   major：架构 / 数据模型不兼容变更
//   minor：新功能 / 行为变化
//   patch：bug 修复 / prompt 调优 / 文案改动
//
// 同时 release date 用 YYYY-MM-DD 标记上线日期，配合版本号让"线上是不是我刚 push 那版"
// 一眼看清楚——不用打开 admin 后台或 git log 比对。
export const APP_VERSION = '5.10.0';
export const APP_RELEASE_DATE = '2026-06-15';
